export const TAG_TYPES = {
    NEW: 'new',
};
